import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Button, { ButtonGroup } from '../../../components/bootstrap/Button';
import { getItem, setItem } from '../../../lib/localstorage';
import AuthService from '../../../services/AuthService';
import showNotification from '../../../components/extras/showNotification';
import { useTranslation } from 'react-i18next';
import { useMst } from '../../../models';
import { localizedLabel } from 'helpers/localizedField';
import { getPersonDisplayName } from 'helpers/personNameI18n';

const SendMailModal = (props) => {
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`userDashboard.${name}`), [t]);
	const { company } = useMst();
	const [selectedUser, setSelectedUser] = useState([]);
	const [isDisabled, setIsDisabled] = useState(false);
	const [result, setResult] = useState(
			getItem('mailResult')
				? JSON.parse(getItem('mailResult'))
				: null);

	const mailStatusText = useMemo(() => 
		(result !== null && result !== undefined)
			? (result
				? t('common.label.success')
				: t('common.label.failure'))
			: t('common.label.pending'), [t, result]);

	useEffect(() => {
		setSelectedUser(props.selectedUser);

		if(JSON.stringify(props.selectedUser) !== getItem('mailSelectedUser')) {
			setResult(null);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.selectedUser]);

	useEffect(() => {
 
		// if (props.isOpenSendMail) setResult(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.isOpenSendMail]);

	return (
		<Modal
			setIsOpen={props.setIsOpenSendMail}
			isOpen={props.isOpenSendMail}
			isStaticBackdrop={false}
			isScrollable={true}
			isCentered={true}
			// fullScreen={true}
		>
			<ModalHeader setIsOpen={props.setIsOpenSendMail}>
				<ModalTitle>{tr('sendAttendanceReportEmail')}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Card className='w-100 h-100 rounded-0' shadow='none' borderSize={1} isScrollable={true}>
					<CardBody isScrollable={true}>
						<div className='table-responsive'>
							<table className='table'>
								<thead>
									<tr>
										<td>#</td>
										<td>{t('common.label.name')}</td>
										<td>{t('filters.position')}</td>
										<td>{t("login.email")}</td>
										<td>{t("common.label.status")}</td>
									</tr>
								</thead>
								<tbody>
									{selectedUser?.map((searchUser, i) => {
 
										return (
											<tr key={`user-${searchUser?.userId}`}>
												<td>{i + 1}</td>
												<td>
													<span className=''>{getPersonDisplayName(searchUser.user)}</span>
												</td>
												<td>
													{searchUser.rank ? (
														<span className='fw-light'>{` ${localizedLabel(t, searchUser.rank)}`}</span>
													) : (
														'-'
													)}
												</td>
												<td>
													<span className='fw-light'>{` ${searchUser.user.email}`}</span>
												</td>
												<td>
													{/* {t(result
														? result?.indexOf?.(searchUser.user.email) > -1
															? t('common.label.fail')
															: t('common.label.successfully')
														: t('common.label.pending'))} */}
													{mailStatusText}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</CardBody>
				</Card>
				<div className='text-start'>
					<Button color={'info'} onClick={props.setIsOpenFindUser}>
						{tr('selectReceivers')}
					</Button>
				</div>
			</ModalBody>
			<ModalFooter>
				<ButtonGroup>
					<Button
						type='button'
						color='success'
						className={'px-5'}
						isDisable={isDisabled}
						onClick={async () => {
							if (selectedUser.length == 0) {
								showNotification(
									tr('sendReportEmail'),
									tr('pleaseChooseReceivers'),
									'danger',
								);
							} else {
								setItem('mailSelectedUser', JSON.stringify(selectedUser));
								setIsDisabled(true);
								const response = await AuthService.attendReportMail2({
									companyId: company.get.id,
									selectedUser: selectedUser,
									attendData: props.attendData || null,
								});
								setIsDisabled(false);
								setResult(response?.result);
								setItem('mailResult', response?.result);
								props.setIsOpenSendMail(false);

							}
						}}>
						{t('common.label.send')}
					</Button>
				</ButtonGroup>
			</ModalFooter>
		</Modal>
	);
};
export default React.memo(SendMailModal);
